export const PORDAL_TOKEN_CONFIG = 'pordal_token_config';
export const USER_TOKEN_NAME = 'auth_session_token';
export const ADMIN_TOKEN_NAME = 'admin_session_token';
export const ADMIN_ACCESS_TOKEN_NAME = 'admin_access_token';
export const USER_SESSION = 'auth_session_user';
export const USER_STATUS = 'user_status';
export const PROPERTY = 'property';
export const PROPERTY_ID = 'property_id';
export const APP_VERSION = 'owner_app_version';
